<form [formGroup]="form" (submit)="submitForm()">
  <mat-card class="p-4 w-7 mx-auto bg-grey-button form-award-endorsement">
    <h2 class="form-award-endorsement__title">
      {{ ProgramTypeName() }}
      <span>Parental Endorsement Form</span></h2>

    <div class="edit-field my-1">
      <label for="parentGuardianName">Parent/Guardian Name <span class="required">*</span></label>
      <input
        id="parentGuardianName"
        matInput
        formControlName="parentGuardianName"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_parent_guardian_name_input"
        data-qa="edit_parent_guardian_name_input" />
      <cfi-form-inline-error [control]="form.get('parentGuardianName')" />
    </div>

    <div class="edit-field my-1">
      <label for="studentName">Student Name</label>
      <input
        id="studentName"
        matInput
        formControlName="studentName"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_student_name_input"
        data-qa="edit_student_name_input" />
    </div>

    <div class="edit-field my-1">
      <label for="studentProgramId">Student PID</label>
      <input
        id="studentProgramId"
        matInput
        formControlName="studentProgramId"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_student_program_id_input"
        data-qa="edit_student_program_id_input" />
    </div>

    <div class="edit-field my-1">
      <label for="permanentAddress">Permanent Address <span class="required">*</span></label>
      <input
        id="permanentAddress"
        matInput
        formControlName="permanentAddress"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_permanent_address_input"
        data-qa="edit_permanent_address_input" />
      <cfi-form-inline-error [control]="form.get('permanentAddress')" />
    </div>

    <div class="edit-field my-1">
      <label for="emailAddress">Email Address <span class="required">*</span></label>
      <input
        id="emailAddress"
        matInput
        type="email"
        formControlName="emailAddress"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_email_address_input"
        data-qa="edit_email_address_input" />
      <cfi-form-inline-error [control]="form.get('emailAddress')" />
    </div>

    <div class="edit-field my-1">
      <label for="schoolName">Name of School</label>
      <input
        id="schoolName"
        matInput
        formControlName="schoolName"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_school_name_input"
        data-qa="edit_school_name_input" />
    </div>

    <div class="edit-field my-1">
      <label for="studentRequiredTuitionAndFees">Student Required Tuition and Fees</label>
      <input
        id="studentRequiredTuitionAndFees"
        matInput
        [value]="formatCurrency(form.get('academicYearIndividualCostTotal')?.value)"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_student_required_tuition_fees_input"
        data-qa="edit_student_required_tuition_fees_input" />
    </div>

    <div class="edit-field my-1">
      <label for="termTuitionAndFees">{{ form.get('termName')?.value }} Tuition and Fees</label>
      <input
        id="termTuitionAndFees"
        matInput
        [value]="formatCurrency(form.get('termTuitionAndFees')?.value)"
        [readonly]="true"
        aria-readonly="true"
        data-pw="edit_term_tuition_fees_input"
        data-qa="edit_term_tuition_fees_input" />
    </div>

    <div class="form-award-endorsement__info-text my-2">
      <p class="italic">
        Any necessary calculations to the Grant Amount have been made. The Grant Amount will be exactly as shown below:
      </p>
    </div>
    @if (form.get('semester')?.value?.toLowerCase() === 'fall') {
      <div class="edit-field my-1">
        <label for="awardAmount">Fall {{ ProgramTypeName() }} Funds to be Sent to School </label>
        <input
          id="awardAmount"
          matInput
          [value]="formatCurrency(form.get('awardAmount')?.value)"
          [readonly]="true"
          aria-readonly="true"
          data-pw="edit_award_amount_input"
          data-qa="edit_award_amount_input" />
      </div>
    }
    @if (form.get('semester')?.value?.toLowerCase() === 'spring') {
      <div class="edit-field my-1">
        <label for="awardAmount">Spring {{ ProgramTypeName() }} Amount</label>
        <input
          id="awardAmount"
          matInput
          [value]="formatCurrency(form.get('awardAmount')?.value)"
          [readonly]="true"
          aria-readonly="true"
          data-pw="edit_award_amount_input"
          data-qa="edit_award_amount_input" />
      </div>
    }
    <div class="form-award-endorsement__instructions my-3">
      <p>By clicking submit, I certify, affirm, and agree to the following statements:</p>
      <ul class="mt-2">
        <li>
          I am the Parent or guardian of the student named above, unless a specific exception granted by the Authority applies.
        </li>
        <li>
          The student is residing in the State of North Carolina at the address listed above.
        </li>
        <li>
          The school named above is the school the student is or will be enrolled in and is or will be attending full-time or part-time.
        </li>
        <li>
          The tuition and fees reported here are true, correct, and accurately reflect the amounts charged by the school for the applicable school year.
        </li>
      </ul>
      
      <ul class="mt-5">
        <li>
          I agree to allow the student to be tested by the nationally standardized test administered by the school as required by the Program.
        </li>
        <li>
          I understand that by pressing submit, I hereby endorse and authorize Program funds to be disbursed directly to the school named here to be credited to an account held by the school for the student named here to pay, in part or in full, the student's tuition and fees as listed above.
        </li>
        <li>
          I understand that acceptance of a refund or rebate of any scholarship funds from the school is prohibited and that if a refund of scholarship funds is warranted, I agree to notify the Authority immediately.
        </li>
        <li>
          I agree not to give my MyPortal account information, including passwords, directly to the school or allow the MyPortal account information to be copied by the school, and I understand that only the Parent or guardian of the student is permitted to complete this Parental Endorsement Form and that neither the school nor any other third-party is permitted to authorize endorsement to the school on the student's behalf.
        </li>
        <li>
          I consent to the disclosure of information from the student's education records to the Authority as may be necessary for it to administer the Program.
        </li>
        <li>
          I agree to comply with all relevant Program statutes, rules, and policies, as well as instructions and requests concerning the Program as may be issued by the Authority.
        </li>
      </ul>

      <p class="mt-3">
        <strong>I understand that providing false, misleading, or incomplete information or actions constituting a violation of Program requirements may result in denial, revocation, or recovery of scholarship funds and may render the student ineligible to participate in the Program. A misuse of State funds under the Program could rise to a civil or criminal offense.</strong>
      </p>

      <p class="mt-3">
        If you have any questions or comments, feel free to contact us:
        @if(programType === ProgramType.OS) { 
          <a href="mailto:OpportunityScholarships@ncseaa.edu">
              OpportunityScholarships@ncseaa.edu 
          </a>.
        }
        @else if(programType === ProgramType.ESA) {
          <a href="mailto:ESA@ncseaa.edu">
            ESA@ncseaa.edu
          </a>
        }
      </p>
    </div>

    <div class="form-award-endorsement__decision my-2">
      <h3>Endorse or Refuse (Parent selects one option) <span class="required">*</span></h3>
      <mat-radio-group formControlName="endorsementDecision" aria-label="Select your endorsement decision">
        <mat-radio-button
          value="endorse"
          data-pw="radio_endorse"
          data-qa="radio_endorse">
          I Endorse the {{ ProgramTypeName() }} funding for {{getTermDisplayValue()}}.
        </mat-radio-button>
        <mat-radio-button
          value="refuse"
          data-pw="radio_refuse"
          data-qa="radio_refuse">
          I Refuse the {{ ProgramTypeName() }} funding for {{getTermDisplayValue()}}.
        </mat-radio-button>
      </mat-radio-group>
      <cfi-form-inline-error [control]="form.get('endorsementDecision')" />
    </div>

    @if (isRefusalSelected()) {
      <div class="edit-field my-1">
        <label for="refusalReason">Reason for Refusal <span class="required">*</span></label>
        <mat-form-field>
          <mat-select
            id="refusalReason"
            placeholder="Please Select"
            formControlName="refusalReason"
            data-pw="edit_refusal_reason_select"
            data-qa="edit_refusal_reason_select">
            @for (reason of getRefusalReasons(); track reason) {
              <mat-option [value]="reason">{{reason}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <cfi-form-inline-error [control]="form.get('refusalReason')" />
      </div>

      @if (isOtherReasonSelected()) {
        <div class="edit-field my-1">
          <label for="refusalReasonOther">Please specify your reason <span class="required">*</span></label>
          <textarea
            id="refusalReasonOther"
            matInput
            formControlName="refusalReasonOther"
            rows="3"
            data-pw="edit_refusal_reason_other_input"
            data-qa="edit_refusal_reason_other_input"></textarea>
          <cfi-form-inline-error [control]="form.get('refusalReasonOther')" />
        </div>
      }
    }

    <div class="form-award-endorsement__parent-name-row">
      <div class="edit-field my-1">
        <label for="parentFirstName">Parent First Name (Required) <span class="required">*</span></label>
        <input
          id="parentFirstName"
          matInput
          formControlName="parentFirstName"
          data-pw="edit_parent_first_name_input"
          data-qa="edit_parent_first_name_input" />
        <cfi-form-inline-error [control]="form.get('parentFirstName')" />
      </div>

      <div class="edit-field my-1">
        <label for="parentLastName">Parent Last Name (Required) <span class="required">*</span></label>
        <input
          id="parentLastName"
          matInput
          formControlName="parentLastName"
          data-pw="edit_parent_last_name_input"
          data-qa="edit_parent_last_name_input" />
        <cfi-form-inline-error [control]="form.get('parentLastName')" />
      </div>
    </div>

    @if (!form.disabled) {
      <div class="button-row">
        <button
          aria-labelledby="Go Back Action"
          color="primary"
          data-qa="upload_back_button"
          data-pw="upload_back_button"
          mat-stroked-button
          tabindex="0"
          (click)="onBack()"
          (keyup)="($event.key === 'Enter' || $event.key === ' ') && onBack()"
        >
          Cancel
        </button>
        <button mat-flat-button type="submit" [disabled]="!isFormReady()" color="primary">Submit</button>
      </div>
    }
  </mat-card>
</form>
